<template>
  <div>
    <a-dropdown>
      <!-- <a class="ant-dropdown-link action">
      <a-avatar class="avatar" size="small" :src="avatar || require('@/assets/images/avatar.png')" />
      <span style="color: #fff">{{ name }}</span>
    </a>-->
      <span class="action" style="display: flex; align-items: center">
        <img
          :src="userAvatar ? userAvatar : require('@/assets/images/avatar.png')"
          class="avatar"
        />
        <span style="color: #fff; font-size: 16px; padding-left: 8px">{{ name }}</span>
      </span>
      <a-menu slot="overlay">
        <a-menu-item>
          <a @click.prevent="toPersonal">
            <a-icon type="user" />
            <span style="padding-left: 8px">{{ $t('account') }}</span>
          </a>
        </a-menu-item>
        <a-menu-item>
          <a @click.prevent="openEdition">
            <a-icon type="reload" />
            <span style="padding-left: 8px">{{ $t('global_header_history_version') }}</span>
          </a>
        </a-menu-item>
        <a-menu-item>
          <a @click.prevent="logout">
            <a-icon type="logout" />
            <span style="padding-left: 8px">{{ $t('logout') }}</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getUserInfo } from '@/utils/auth'

export default {
  name: '',
  data() {
    return {
      userAvatar: '',
      name: ''
    }
  },
  computed: {
    ...mapGetters(['avatar', 'user'])
  },
  watch: {
    avatar: {
      handler(val) {
        // 存于vuex里的用户头像
        // 存于storage里的用户信息
        let sessionAvatar = getUserInfo() ? getUserInfo().avatar : ''
        this.userAvatar = val ? val : sessionAvatar ? sessionAvatar : ''
      },
      immediate: true
    },
    user: {
      handler(val) {
        let name = getUserInfo() ? getUserInfo().nick_name : ''
        this.name = val.nick_name ? val.nick_name : name ? name : ''
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toPersonal() {
      this.$router.push('/platform/personal')
    },
    openEdition() {
      this.$emit('openEdition')
    },
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$router.push('/login')
      })
    }
  }
}
</script>
